(function () {
  window.removingGwpGiftsInProgress = window.removingGwpGiftsInProgress || false;

  function getCartDrawerSectionIds() {
    const drawerSection =
      (typeof window.getCartDrawerSectionId === 'function' && window.getCartDrawerSectionId()) || 'cart-drawer';
    return [drawerSection, 'cart-icon-bubble'];
  }

  function isCartDrawerScrollLocked(cartDrawer) {
    return Boolean(cartDrawer?.classList.contains('active'));
  }

  function restoreCartDrawerFocusTrap(cartDrawer, elementToFocus = null) {
    if (!cartDrawer?.classList.contains('active') || typeof trapFocus !== 'function') {
      return;
    }

    const containerToTrapFocusOn = cartDrawer.classList.contains('is-empty')
      ? cartDrawer.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    if (!containerToTrapFocusOn) return;

    const defaultFocus =
      cartDrawer.querySelector('.drawer__inner') || cartDrawer.querySelector('.drawer__close');
    trapFocus(containerToTrapFocusOn, elementToFocus || defaultFocus);
  }

  function refreshCartDrawerSections(cartState) {
    if (!cartState?.sections) return false;

    const drawerSectionId = getCartDrawerSectionIds()[0];
    const drawerHtml = cartState.sections[drawerSectionId] || cartState.sections['cart-drawer'];
    if (drawerHtml && typeof syncCartDrawerFromSection === 'function') {
      syncCartDrawerFromSection(drawerHtml, cartState, '.cart-drawer');
    }

    const bubbleHtml = cartState.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const sourceBubble = parsed.querySelector('.shopify-section');
      const targetBubble = document.getElementById('cart-icon-bubble')?.querySelector('.shopify-section');
      if (sourceBubble && targetBubble) {
        targetBubble.innerHTML = sourceBubble.innerHTML;
      }
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartState.item_count === 'number') {
      cartDrawer.classList.toggle('is-empty', cartState.item_count === 0);
    }

    document.querySelector('cart-drawer-items')?.maxPerOrder?.();
    publish(PUB_SUB_EVENTS.renderCartDrawerCachedContent, { source: 'cart-milestones' });
    return true;
  }

  function publishCartSynced() {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cart-milestones',
      drawerSectionsRefreshed: true,
    });
  }

  function cartSectionsPayload() {
    return {
      sections: getCartDrawerSectionIds(),
      sections_url: window.location.pathname,
    };
  }

  function setMilestoneButtonLabel(button, text) {
    if (!button) return;
    let label = button.querySelector('.cart-milestones__button-text');
    if (!label) {
      label = document.createElement('span');
      label.className = 'cart-milestones__button-text';
      button.replaceChildren(label);
    }
    label.textContent = text;
  }

  function decodeHtmlEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function renderCartMilestoneMessageHtml(root) {
    if (!root) return;
    root.querySelectorAll('.cart-milestones__message').forEach((el) => {
      if (el.children.length > 0) return;
      const raw = el.textContent?.trim() ?? '';
      if (!raw) return;
      const decoded = decodeHtmlEntities(raw);
      if (/<\/?[a-z][^>]*>/i.test(decoded)) {
        el.innerHTML = decoded;
      } else if (decoded !== raw) {
        el.textContent = decoded;
      }
    });
  }

  window.renderCartMilestoneMessageHtml = renderCartMilestoneMessageHtml;

  function normalizeGwpPromoSrc(src) {
    if (!src) return '';
    try {
      const parsed = new URL(src, window.location.origin);
      if (!parsed.searchParams.has('width')) {
        parsed.searchParams.set('width', '128');
      }
      return parsed.href;
    } catch (e) {
      return src;
    }
  }

  // Theme promo image (admin override) on its own, otherwise one thumbnail per offer gift.
  function resolveGwpPromoImages(root) {
    const drawerThemeSrc = document.querySelector('cart-drawer')?.getAttribute('data-gwp-theme-promo-src')?.trim();
    const rootThemeSrc = root?.getAttribute('data-gwp-theme-promo-src')?.trim();
    const themeSrc = drawerThemeSrc || rootThemeSrc;
    if (themeSrc) return [{ src: normalizeGwpPromoSrc(themeSrc), alt: '' }];

    const splitList = (value) => (value || '').split('|').map((part) => part.trim());
    const giftSrcs = splitList(root?.getAttribute('data-gwp-gift-srcs')).filter(Boolean);
    const giftAlts = splitList(root?.getAttribute('data-gwp-gift-alts'));
    if (giftSrcs.length > 0) {
      return giftSrcs.map((src, index) => ({ src: normalizeGwpPromoSrc(src), alt: giftAlts[index] || '' }));
    }

    const promoSrc = root?.getAttribute('data-gwp-promo-src')?.trim();
    return promoSrc ? [{ src: normalizeGwpPromoSrc(promoSrc), alt: '' }] : [];
  }

  function createGwpPromoImg() {
    const img = document.createElement('img');
    img.setAttribute('width', '30');
    img.setAttribute('height', '30');
    img.setAttribute('loading', 'eager');
    img.setAttribute('decoding', 'async');
    img.setAttribute('fetchpriority', 'high');
    return img;
  }

  // Returns the header thumbnails (or [] when none should show).
  function ensureGwpPromoImages(root) {
    if (!root) return [];

    const hasGwpAdd = Boolean(root.querySelector('.js-cart-milestones-gwp-add'));
    const syncParts = root.getAttribute('data-ui-sync-key')?.split('|');
    const promoFlagOn = syncParts?.length >= 4 && syncParts[3] === '1';
    if (!promoFlagOn && !hasGwpAdd) {
      root.querySelector('.cart-milestones__gwp-image')?.remove();
      return [];
    }

    const images = resolveGwpPromoImages(root);
    if (images.length === 0) return [];

    const headerStart =
      root.querySelector('.cart-milestones__header .cart-milestones__header-start') ||
      root.querySelector('.cart-milestones__header');
    if (!headerStart) return [];

    let wrap = headerStart.querySelector('.cart-milestones__gwp-image');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'cart-milestones__gwp-image';
      headerStart.insertBefore(wrap, headerStart.firstChild);
      root.querySelector('.cart-milestones__header')?.classList.remove('cart-milestones__header--ready');
    }

    const imgs = Array.from(wrap.querySelectorAll('img'));
    imgs.slice(images.length).forEach((img) => img.remove());

    const fallbackAlt = root.querySelector('.cart-milestones__message')?.textContent?.trim() || '';
    return images.map(({ src, alt }, index) => {
      let img = imgs[index];
      if (!img) {
        img = createGwpPromoImg();
        wrap.appendChild(img);
      }
      if (normalizeGwpPromoSrc(img.getAttribute('src') || '') !== src) {
        img.setAttribute('src', src);
      }
      if (!img.getAttribute('alt')) {
        img.setAttribute('alt', alt || fallbackAlt);
      }
      return img;
    });
  }

  function ensureGwpPromoImage(root) {
    return ensureGwpPromoImages(root)[0] || null;
  }

  function stabilizeGwpHeader(root) {
    if (!root) return;
    const header = root.querySelector('.cart-milestones__header');
    if (!header) return;

    let imgs = ensureGwpPromoImages(root);
    if (imgs.length === 0) imgs = Array.from(header.querySelectorAll('.cart-milestones__gwp-image img'));
    header.classList.remove('cart-milestones__header--ready');

    const pending = imgs.filter((img) => !(img.complete && img.naturalWidth > 0));
    if (pending.length === 0) {
      header.classList.add('cart-milestones__header--ready');
      return;
    }

    let remaining = pending.length;
    let revealed = false;
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      header.classList.add('cart-milestones__header--ready');
    };
    const settle = () => {
      remaining -= 1;
      if (remaining <= 0) reveal();
    };
    pending.forEach((img) => {
      img.addEventListener('load', settle, { once: true });
      img.addEventListener('error', settle, { once: true });
    });
    window.setTimeout(reveal, 2500);
  }

  window.ensureGwpPromoImage = ensureGwpPromoImage;
  window.stabilizeGwpHeader = stabilizeGwpHeader;

  // Gifts already auto-added while the cart stayed qualified. Lets a customer remove an
  // auto-added gift without it being re-added on the next render. Reset when the cart
  // drops below the threshold.
  const GWP_AUTO_ADDED_STORAGE_KEY = 'gwpAutoAddedVariantIds';
  // Gifts seen in the cart while qualified. One of these going missing means the customer
  // removed it, which is the only case the header ADD is shown for.
  const GWP_SEEN_IN_CART_STORAGE_KEY = 'gwpSeenInCartVariantIds';
  const gwpIdSetFallback = {};

  function readGwpAutoAdded(key = GWP_AUTO_ADDED_STORAGE_KEY) {
    try {
      const stored = JSON.parse(window.sessionStorage.getItem(key) || '[]');
      return new Set(Array.isArray(stored) ? stored.map(String) : []);
    } catch (e) {
      return new Set(gwpIdSetFallback[key] || []);
    }
  }

  function writeGwpAutoAdded(ids, key = GWP_AUTO_ADDED_STORAGE_KEY) {
    gwpIdSetFallback[key] = Array.from(ids);
    try {
      window.sessionStorage.setItem(key, JSON.stringify(gwpIdSetFallback[key]));
    } catch (e) {
      // sessionStorage unavailable — in-memory fallback only
    }
  }

  window.addingGwpGiftsInProgress = window.addingGwpGiftsInProgress || false;

  class CartMilestones extends HTMLElement {
    refreshDomState() {
      this.addButton = this.querySelector('.js-cart-milestones-gwp-add');
      this.backButton = this.querySelector('.js-cart-milestones-gwp-back');
      this.selectionPanel = this.querySelector('.cart-milestones__gwp-modal');
      this.counterEl = this.querySelector('.js-cart-milestones-gwp-counter');

      const parsedGwpTotal = parseInt(this.selectionPanel?.dataset.gwpLimit ?? '1', 10);
      this.gwpTotalLimit = Number.isFinite(parsedGwpTotal) ? Math.max(0, parsedGwpTotal) : 1;
      const parsedInCart = parseInt(this.selectionPanel?.dataset.gwpInCartCount ?? '0', 10);
      this.gwpInCartCount = Number.isFinite(parsedInCart) ? Math.max(0, parsedInCart) : 0;
      this.gwpRemaining = Math.max(0, this.gwpTotalLimit - this.gwpInCartCount);
      this.addedLabel = this.selectionPanel?.dataset.addedLabel || 'ADDED';
      this.addLabel = this.selectionPanel?.dataset.addLabel || 'ADD';
    }

    getMaxPendingSelections() {
      return Math.max(0, this.gwpTotalLimit - this.gwpInCartCount);
    }

    isGiftOptionInCart(button) {
      if (!button) return false;
      return Boolean(button.closest('.cart-milestones__gwp-option-card--in-cart'));
    }

    getPendingSelectableVariantIds() {
      return Array.from(this.selectedVariantIds).filter((variantId) => {
        const button = this.querySelector(
          `.js-cart-milestones-gwp-select[data-variant-id="${CSS.escape(String(variantId))}"]`,
        );
        return button && !this.isGiftOptionInCart(button);
      });
    }

    syncGiftOptionsFromCartItems(cartItems) {
      const modal = this.selectionPanel;
      if (!modal) return;

      const gwpLineKeysByVariant = new Map(
        (cartItems || [])
          .filter((item) => {
            const props = item.properties || {};
            return props._gwp === true || props._gwp === 'true';
          })
          .map((item) => [String(item.variant_id), item.key]),
      );

      let inCartCount = 0;
      this.querySelectorAll('.js-cart-milestones-gwp-select').forEach((button) => {
        const variantId = button.getAttribute('data-variant-id');
        const inCart = Boolean(variantId && gwpLineKeysByVariant.has(String(variantId)));
        const card = button.closest('.cart-milestones__gwp-option-card');

        if (inCart) {
          inCartCount += 1;
          this.selectedVariantIds.delete(variantId);
          button.dataset.lineKey = gwpLineKeysByVariant.get(String(variantId)) || '';
          button.removeAttribute('disabled');
          button.classList.add('cart-milestones__gwp-option-select--selected');
          button.setAttribute('aria-pressed', 'true');
          card?.classList.add('cart-milestones__gwp-option-card--in-cart');
          setMilestoneButtonLabel(button, this.addedLabel);
          return;
        }

        delete button.dataset.lineKey;
        button.removeAttribute('disabled');
        card?.classList.remove('cart-milestones__gwp-option-card--in-cart');
        if (!this.selectedVariantIds.has(variantId)) {
          button.classList.remove('cart-milestones__gwp-option-select--selected');
          button.removeAttribute('aria-pressed');
          setMilestoneButtonLabel(button, this.addLabel);
        }
      });

      const limit = Number.parseInt(modal.dataset.gwpLimit ?? '', 10);
      const totalLimit = Number.isFinite(limit) && limit > 0 ? limit : this.gwpTotalLimit;
      const effectiveInCart = Math.min(inCartCount, totalLimit);
      modal.dataset.gwpInCartCount = String(effectiveInCart);
      modal.dataset.gwpRemaining = String(Math.max(0, totalLimit - effectiveInCart));
      this.gwpTotalLimit = totalLimit;
      this.gwpInCartCount = effectiveInCart;
      this.gwpRemaining = Math.max(0, totalLimit - effectiveInCart);
      this.updateSelectionCounter();
      this.syncGwpAddVisibility();
    }

    resetPendingSelection() {
      this.selectedVariantIds.clear();
      this.querySelectorAll('.js-cart-milestones-gwp-select:not([disabled])').forEach((button) => {
        if (this.isGiftOptionInCart(button)) return;
        button.classList.remove('cart-milestones__gwp-option-select--selected');
        setMilestoneButtonLabel(button, this.addLabel);
        button.removeAttribute('aria-pressed');
      });
      this.updateSelectionCounter();
    }

    // Header ADD only after the customer removed a gift; hidden while gifts are (being) auto-added.
    syncGwpAddVisibility() {
      if (this.getAttribute('data-gwp-qualified') !== 'true') {
        this.classList.remove('cart-milestones--gwp-add-allowed');
        return;
      }

      const seen = readGwpAutoAdded(GWP_SEEN_IN_CART_STORAGE_KEY);
      const missing = [];
      this.querySelectorAll('.js-cart-milestones-gwp-select').forEach((button) => {
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;
        if (this.isGiftOptionInCart(button)) {
          seen.add(variantId);
        } else {
          missing.push(variantId);
        }
      });
      writeGwpAutoAdded(seen, GWP_SEEN_IN_CART_STORAGE_KEY);

      // Missing gifts the customer removed, or that auto-add tried but couldn't add (failed or
      // partial request) — the modal is then the only way to get them. Hidden while a request runs.
      const attempted = window.addingGwpGiftsInProgress ? new Set() : readGwpAutoAdded();
      this.classList.toggle(
        'cart-milestones--gwp-add-allowed',
        missing.some((variantId) => seen.has(variantId) || attempted.has(variantId)),
      );
    }

    maybeAutoRemoveGifts() {
      if (window.batchCartClearInProgress) return;
      if (this.getAttribute('data-gamification-enabled') === 'false') return;

      const giftsToRemove = this.getAttribute('data-remove-gift');
      if (!giftsToRemove || window.removingGwpGiftsInProgress) return;

      this.removeAttribute('data-remove-gift');
      let keysToRemove = giftsToRemove
        .split(',')
        .map((key) => key.trim())
        .filter(Boolean);
      if (typeof pendingGwpRemovalKeys !== 'undefined' && pendingGwpRemovalKeys.size > 0) {
        keysToRemove = keysToRemove.filter((key) => !pendingGwpRemovalKeys.has(key));
      }
      if (keysToRemove.length === 0) return;

      const keysPayload = keysToRemove.join(',');
      if (typeof markGwpLinesRemoving === 'function') {
        markGwpLinesRemoving(keysPayload);
      }
      this.handleRemoveGift(keysPayload);
    }

    maybeAutoAddGifts() {
      if (window.batchCartClearInProgress) return;
      if (this.getAttribute('data-gamification-enabled') === 'false') return;

      if (this.getAttribute('data-gwp-qualified') !== 'true') {
        writeGwpAutoAdded(new Set());
        writeGwpAutoAdded(new Set(), GWP_SEEN_IN_CART_STORAGE_KEY);
        return;
      }
      const giftsToAdd = this.getAttribute('data-auto-add-gifts');
      if (!giftsToAdd) return;
      if (window.addingGwpGiftsInProgress || window.removingGwpGiftsInProgress || this.addingGift) return;
      if (typeof pendingGwpRemovalKeys !== 'undefined' && pendingGwpRemovalKeys.size > 0) return;

      // Skip gifts already auto-added, and gifts seen in the cart this session (recorded by
      // syncGwpAddVisibility, which runs first) — e.g. already in the cart when the session began.
      // Either way, missing now means the customer removed it.
      const alreadyAutoAdded = readGwpAutoAdded();
      const seenInCart = readGwpAutoAdded(GWP_SEEN_IN_CART_STORAGE_KEY);
      const ids = giftsToAdd
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id && !alreadyAutoAdded.has(id) && !seenInCart.has(id));

      this.removeAttribute('data-auto-add-gifts');
      if (ids.length === 0) return;

      ids.forEach((id) => alreadyAutoAdded.add(id));
      writeGwpAutoAdded(alreadyAutoAdded);

      window.addingGwpGiftsInProgress = true;

      const addGifts = (variantIds) =>
        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: variantIds.map((id) => ({
              id: Number.parseInt(id, 10),
              quantity: 1,
              properties: { _gwp: true },
            })),
            ...cartSectionsPayload(),
          }),
        }).then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        });

      // One unavailable gift fails the whole batch — fall back to adding gifts one by one
      // and keep whichever succeed.
      const addGiftsIndividually = () =>
        ids.reduce(
          (chain, id) =>
            chain.then((lastState) =>
              addGifts([id])
                .then((cartState) => cartState)
                .catch((error) => {
                  console.warn(`GWP gift ${id} could not be auto-added:`, error);
                  return lastState;
                }),
            ),
          Promise.resolve(null),
        ).then((cartState) => {
          if (!cartState) throw new Error('No GWP gifts could be auto-added');
          return cartState;
        });

      addGifts(ids)
        .catch(() => (ids.length > 1 ? addGiftsIndividually() : Promise.reject(new Error('GWP gift unavailable'))))
        .then((cartState) => {
          window.addingGwpGiftsInProgress = false;
          if (!refreshCartDrawerSections(cartState)) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-milestones' });
            return;
          }
          publishCartSynced();
        })
        .catch((error) => {
          console.error('Error auto-adding GWP gifts:', error);
          window.addingGwpGiftsInProgress = false;
          // No drawer refresh follows a failure, so reveal ADD for the gifts that didn't make it.
          const live = this.isConnected ? this : document.querySelector('cart-milestones');
          live?.syncGwpAddVisibility?.();
        });
    }

    connectedCallback() {
      this._abortController?.abort();
      this._abortController = new AbortController();
      const { signal } = this._abortController;

      this.addingGift = false;
      this.removingGiftOption = false;
      this.selectedVariantIds = new Set();

      this.refreshDomState();
      this.syncGwpAddVisibility();
      renderCartMilestoneMessageHtml(this);
      stabilizeGwpHeader(this);

      this.addEventListener(
        'click',
        (event) => {
          const addBtn = event.target.closest('.js-cart-milestones-gwp-add');
          if (addBtn && this.contains(addBtn)) {
            event.preventDefault();
            if (!this.selectionPanel) return;
            this.openGiftSelection();
            return;
          }

          const backBtn = event.target.closest('.js-cart-milestones-gwp-back');
          if (backBtn && this.contains(backBtn)) {
            event.preventDefault();
            this.closeGiftSelection();
            return;
          }

          // Gifts are added/removed on tap, so Apply only closes the popup.
          const applyBtn = event.target.closest('.js-cart-milestones-gwp-apply');
          if (applyBtn && this.contains(applyBtn)) {
            event.preventDefault();
            this.closeGiftSelection();
            return;
          }

          const selectBtn = event.target.closest('.js-cart-milestones-gwp-select');
          if (selectBtn && this.contains(selectBtn)) {
            event.preventDefault();
            if (this.addingGift || this.removingGiftOption) return;
            if (this.isGiftOptionInCart(selectBtn)) {
              this.handleRemoveGiftOption(selectBtn);
              return;
            }
            this.handleAddGiftOption(selectBtn);
          }
        },
        { signal }
      );

      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || !this.selectionPanel || this.selectionPanel.hasAttribute('hidden')) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          this._gwpEscapeConsumesKeyup = true;
          this.closeGiftSelection();
        },
        { signal }
      );

      this.addEventListener(
        'keyup',
        (event) => {
          if (event.key !== 'Escape') return;
          const modalOpen = this.selectionPanel && !this.selectionPanel.hasAttribute('hidden');
          if (!modalOpen && !this._gwpEscapeConsumesKeyup) return;
          event.preventDefault();
          event.stopPropagation();
          this._gwpEscapeConsumesKeyup = false;
        },
        { signal }
      );

      this.addEventListener(
        'cart-milestones:content-updated',
        () => {
          this.selectedVariantIds.clear();
          this.refreshDomState();
          this.syncGwpAddVisibility();
          renderCartMilestoneMessageHtml(this);
          stabilizeGwpHeader(this);
          this.maybeAutoRemoveGifts();
          this.maybeAutoAddGifts();
          this.updateSelectionCounter();
        },
        { signal }
      );

      this.maybeAutoRemoveGifts();
      this.maybeAutoAddGifts();
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this.closeGiftSelection(false);
    }

    openGiftSelection() {
      const revealModal = () => {
        this.resetPendingSelection();
        const cartDrawer = this.closest('cart-drawer');
        this.classList.add('cart-milestones--gwp-open');
        cartDrawer?.classList.add('cart-drawer--gwp-modal-open');
        this.selectionPanel?.removeAttribute('hidden');
        this.addButton?.setAttribute('aria-expanded', 'true');
        if (!isCartDrawerScrollLocked(cartDrawer)) {
          document.body.classList.add('overflow-hidden');
        }
        this.updateSelectionCounter();
        const focusTarget = this.backButton || this.selectionPanel;
        if (typeof trapFocus === 'function' && this.selectionPanel) {
          trapFocus(this.selectionPanel, focusTarget);
        } else {
          focusTarget?.focus();
        }
      };

      this.refreshDomState();

      fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((cart) => {
          this.syncGiftOptionsFromCartItems(cart.items || []);
          revealModal();
        })
        .catch(() => {
          revealModal();
        });
    }

    closeGiftSelection(restoreFocus = true) {
      const cartDrawer = this.closest('cart-drawer');
      const focusTarget = restoreFocus ? this.addButton : null;

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(focusTarget);
      } else if (focusTarget) {
        focusTarget.focus();
      }

      this.classList.remove('cart-milestones--gwp-open');
      cartDrawer?.classList.remove('cart-drawer--gwp-modal-open');
      this.selectionPanel?.setAttribute('hidden', '');
      this.addButton?.setAttribute('aria-expanded', 'false');
      if (!isCartDrawerScrollLocked(cartDrawer)) {
        document.body.classList.remove('overflow-hidden');
      }
      this.clearSelection();
      restoreCartDrawerFocusTrap(cartDrawer, focusTarget);
    }

    clearSelection() {
      this.resetPendingSelection();
    }

    updateSelectionCounter() {
      const pendingCount = this.getPendingSelectableVariantIds().length;
      const filledCount = Math.min(this.gwpTotalLimit, this.gwpInCartCount + pendingCount);
      if (this.counterEl) {
        this.counterEl.textContent = `${filledCount}/${this.gwpTotalLimit}`;
      }
    }

    markGiftOptionInCart(button, lineKey) {
      const card = button.closest('.cart-milestones__gwp-option-card');
      card?.classList.add('cart-milestones__gwp-option-card--in-cart');
      button.classList.add('cart-milestones__gwp-option-select--selected');
      button.setAttribute('aria-pressed', 'true');
      if (lineKey) button.dataset.lineKey = lineKey;
      setMilestoneButtonLabel(button, this.addedLabel);

      this.gwpInCartCount = Math.min(this.gwpTotalLimit, this.gwpInCartCount + 1);
      this.gwpRemaining = Math.max(0, this.gwpTotalLimit - this.gwpInCartCount);
      if (this.selectionPanel) {
        this.selectionPanel.dataset.gwpInCartCount = String(this.gwpInCartCount);
        this.selectionPanel.dataset.gwpRemaining = String(this.gwpRemaining);
      }
    }

    // Tapping ADD puts the gift straight in the cart; the modal stays open.
    handleAddGiftOption(button) {
      const variantId = Number.parseInt(button.getAttribute('data-variant-id') || '', 10);
      if (!Number.isFinite(variantId) || this.getMaxPendingSelections() <= 0) return;

      this.addingGift = true;
      this.setGiftOptionLoading(button, true);

      fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _gwp: true } }],
          ...cartSectionsPayload(),
        }),
      })
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        })
        .then((cartState) => {
          this.markGiftOptionInCart(button, cartState?.items?.[0]?.key);
          if (!refreshCartDrawerSections(cartState)) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-milestones' });
            return;
          }
          publishCartSynced();
        })
        .catch((error) => {
          console.error('Error adding GWP gift:', error);
        })
        .finally(() => {
          this.addingGift = false;
          this.setGiftOptionLoading(button, false);
          this.updateSelectionCounter();
        });
    }

    setGiftOptionLoading(button, isLoading) {
      button.classList.toggle('loading', isLoading);
      button.querySelector('.loading-overlay__spinner')?.classList.toggle('hidden', !isLoading);
      if (isLoading) {
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      }
    }

    handleRemoveGiftOption(button) {
      const lineKey = button.dataset.lineKey;
      if (!lineKey) return;

      this.removingGiftOption = true;
      this.setGiftOptionLoading(button, true);

      fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          ...cartSectionsPayload(),
        }),
      })
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        })
        .then((cartState) => {
          // The open modal is preserved across drawer refreshes, so update its options here.
          this.syncGiftOptionsFromCartItems(cartState.items || []);
          if (!refreshCartDrawerSections(cartState)) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-milestones' });
            return;
          }
          publishCartSynced();
        })
        .catch((error) => {
          console.error('Error removing GWP gift:', error);
        })
        .finally(() => {
          this.removingGiftOption = false;
          this.setGiftOptionLoading(button, false);
          this.updateSelectionCounter();
        });
    }

    handleRemoveGift(giftKeys) {
      const updates = {};
      giftKeys.split(',').forEach((key) => {
        const trimmed = key.trim();
        if (trimmed) updates[trimmed] = 0;
      });

      if (Object.keys(updates).length === 0) return;

      window.removingGwpGiftsInProgress = true;

      fetch(`${routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          ...cartSectionsPayload(),
        }),
      })
        .then((response) => response.json())
        .then((cartState) => {
          if (!refreshCartDrawerSections(cartState)) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-milestones' });
            return;
          }
          publishCartSynced();
        })
        .catch((error) => {
          console.error('Error removing GWP gift:', error);
          if (typeof clearGwpLinesRemoving === 'function') {
            clearGwpLinesRemoving();
          }
        })
        .finally(() => {
          window.removingGwpGiftsInProgress = false;
          if (typeof reapplyPendingGwpRemovalHiding === 'function') {
            reapplyPendingGwpRemovalHiding();
          }
        });
    }
  }

  if (!customElements.get('cart-milestones')) {
    customElements.define('cart-milestones', CartMilestones);
  }
})();
